module.exports = __webpack_public_path__ + "img/qr_code_new.a47b5573.jpeg";